// work data

export const Work = [
    {
        id:1,
        name:"Dex Swap",
        description:"It is build on top of the React JS, Solidity, Uniswap Api with styledComponents and GSAP for smooth scrolling.",
        tags:["react","solidity","uniswap", "blockchain"],
        
        demo:"https://clientswap.netlify.app/",
        github:"https://github.com/fahimahamed999/100xswap"
    },
    {
        id:2,
        name:"Metaverse Game",
        description:"Metaverse Based Unity Game.",
        tags:["unity","C#","React","Blockchain"],
        
        demo:"https://avatax.io/",
        github:"https://github.com/fahimahamed999/underworld-capitalist-game"
        
    },
    {
        id:3,
        name:"NFT MMarketplace",
        description:"A full stack nft marketplace.",
        tags:["react","solidity","blockchain","ethereum"],
        
        demo:"https://nft-pornverse.vercel.app/home",
        github:"https://nft-pornverse.vercel.app/home"
    },
    {
        id:4,
        name:"Crypto Wallet",
        description:"A cool looking php crypto wallet.",
        tags:["css","laravel","blockchain"],
        
        demo:"https://exchange.rsltoken1.com",
        github:"https://github.com/fahimahamed999/wallet"
       
    },{
        id:5,
        name:"Trust wallet clone (Android)",
        description:"A todo app build using Redux-toolkit and framer-motion for smooth animations.",
        tags:["blockchain","redux","framer-motion","java"],
        
        demo:"https://github.com/fahimahamed999/wallet",
        github:"https://github.com/fahimahamed999/wallet"
        
    },
    {
        id:6,
        name:"Tron Exchange",
        description:"Tron Exchange cliennt exchange",
        tags:["react","react-router","css"],
        
        demo:"https://github.com/fahimahamed999/tron-clent",
        github:"https://github.com/fahimahamed999/tron-clent"
        
    },
    
  
] 